import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';
import { FPCodeGeneratorDTO } from '../../Interfaces/DTOs';
import { getAuthToken } from '../../Helper/authToken';

const externalAuthApi = createApi({
  reducerPath: 'externalAuthApi',
  baseQuery: fetchBaseQuery({
    baseUrl: `${process.env.REACT_APP_APIBaseUrl}/externalAuth`,
  }),
  endpoints: (builder) => ({
    getPreLoginMethods: builder.query({
      query: () => {
        return {
          url: 'pre-login-methods',
          headers: {
            Authorization: `Bearer ${getAuthToken()}`,
            'Content-type': 'application/json',
          },
        };
      },
    }),
    getPreLogin: builder.query({
      query: () => ({
        url: 'pre-login',
      }),
    }),
    externalLogin: builder.mutation({
      query: ({
        provider,
        requestBody,
      }: {
        provider: string;
        requestBody: string;
      }) => ({
        url: `social-login/${provider}`,
        method: 'POST',
        headers: {
          'Content-type': 'application/json',
        },
        body: JSON.stringify(requestBody),
      }),
    }),
    generateCode: builder.mutation({
      query: (obj: FPCodeGeneratorDTO) => ({
        url: 'generateCode',
        method: 'POST',
        body: obj,
      }),
    }),
    resendCode: builder.mutation({
      query: ({provider, requestBody}: {
        provider: string;
        requestBody: string;
      }) => ({
        url: `resendCode/${provider}`,
        method: 'POST',
        headers: {
          'Content-type': 'application/json',
        },
        body: JSON.stringify(requestBody),
      }),
    }),
  }),
});

export const {
  useGetPreLoginMethodsQuery,
  useGetPreLoginQuery,
  useExternalLoginMutation,
  useGenerateCodeMutation,
  useResendCodeMutation,
} = externalAuthApi;
export default externalAuthApi;
